import React from "react"

const EditarFacturaDesdeArticulos = () => {
  return <div>EditarFacturaDesdeArticulos</div>
}

export default EditarFacturaDesdeArticulos
